
import {defineComponent, ref, Ref, watch} from "vue";
  import { useStore } from "vuex";
import {FormGetters} from './../../Store/index';
  import { CarItem } from './../../Store/form/types';
  import { isStepAvailable } from './../../Composables/form';

  import RadioComponent from "./../Form/RadioComponent.vue";
  import SelectComponent from "./../Form/SelectComponent.vue";
  import DateComponent from "./../Form/DateComponent.vue";
  import InputComponent from "./../Form/InputComponent.vue";

  import { getCarsBelowThreshold } from "./../../Composables/form";

  export default defineComponent({
    name: "MotorcycleComponent",

    computed: {
      FormGetters() {
        return FormGetters
      }
    },

    components: {
      SelectComponent,
      RadioComponent,
      DateComponent,
      InputComponent
    },

    props: {},

    setup() {
      // Get the Vuex store instance
      const store = useStore();

      // Get various data from the store using getters
      const labels = store.getters[`form/${FormGetters.GET_LABELS}`];

      let carsBelowThreshold: Ref<CarItem[]> = ref([]);

      // Watch for changes in car count
      watch(() => store.getters[`form/${FormGetters.GET_DATA}`].vehicleSelection.value, async (newVehicleSelection) => {
        carsBelowThreshold.value = getCarsBelowThreshold(store);
      }, { deep: true });

      // Return the data
      return {
        labels,
        carsBelowThreshold,
        isStepAvailable,
        store
      }
    }
  })
